import { addClientFilteringMetaData } from '../generators/filteringMetaDataGenerator';
import initialstate from './state';

export function setUser(state, payload) {
    state.user = payload;
}

export function setClients(state, payload) {
    state.clients = payload;
}

export function setClientsLoaded(state, payload) {
    state.clientsLoaded = payload;
}

export function clearAllState(state) {
    Object.assign(state, initialstate);
}

export function setLabels(state, payload) {
    var item = state.clients.find((c) => c.id === payload.accountId);
    var client = item;

    if (payload.websiteId) {
        item = state.clients
            .map((c) => c.websites)
            .reduce(function (a, b) {
                return a.concat(b);
            }, [])
            .find((w) => w.id === payload.websiteId);
        client = state.clients.find((c) => c.id === item.clientId);
    }

    item.convenienceName = payload.convenienceName;
    item.clientContact = payload.clientContact;
    item.partnerContact = payload.partnerContact;

    addClientFilteringMetaData(client);
}

export function setUsers(state, payload) {
    state.users = payload;
}

export function addUser(state, payload) {
    state.users.push(payload);
}

export function removeUser(state, payload) {
    let idx = state.users.findIndex((el) => el.id === payload.id);
    state.users.splice(idx, 1);
}

export function setUsersLoaded(state, payload) {
    state.usersLoaded = payload;
}

export function setPartner(state, payload) {
    setFromObject(state.partner, payload);
}

export function setApplicationInfo(state, payload) {
    setFromObject(state.applicationInfo, payload);
}

export function setSignUpUser(state, payload) {
    state.signUpUser.email = payload.email;
    state.signUpUser.password = payload.password;
}

export function setQRCodeDetails(state, payload) {
    state.qrCode.qrCodeUrl = payload.qrCodeUrl;
    state.qrCode.manualEntryCode = payload.manualEntry;
}

export function addClientInvitation(state, payload) {
    state.clientInvitations.push(payload);
}

export function setPartnerTransactions(state, { results, totalCount }) {
    state.partnerTransactions = [];
    state.partnerTransactions = results;
    state.partnerTransactionsTotal = totalCount;
}
export function setPartnerTransactionsLoading(state, payload) {
    state.partnerTransactionsLoading = payload;
}

export function setPartnerTransactionsSums(state, payload) {
    state.partnerTransactionsSums = payload;
}

function setFromObject(state, obj) {
    Object.keys(obj).forEach((key) => {
        state[key] = obj[key];
    });
}

export function setCommission(state, payload) {
    state.commission = payload;
}
